import React from "react";
import "./BillsContainer.css";
import Bill from "../Bill/Bill";

const BillsContainer = ({ bills, onBillClick, isLoading }) => {
  if (!bills.length) {
    return <div className="status-message">No bills found.</div>;
  }

  return (
    <section className="grid" id="newsGrid">
      {bills.map((bill) => (
        <Bill key={`${bill.date}-${bill.title}`} bill={bill} onClick={() => onBillClick(bill)} />
      ))}
    </section>
  );
};

const BillsContainerWrapper = ({ bills, onBillClick, isLoading }) => {
  if (isLoading) {
    return (
      <div className="loading-container" role="status" aria-live="polite">
        <div className="spinner" aria-hidden="true"></div>
        <span className="visually-hidden">Loading bills…</span>
      </div>
    );
  }

  return <BillsContainer bills={bills} onBillClick={onBillClick} isLoading={false} />;
};

export default BillsContainerWrapper;
